import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "History Upload Data Excel ")
  ])
], -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-start" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = {
  class: "col-5",
  style: {"text-align":"end"}
}
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px; text-center" }, "File Upload"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Creator"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Detail"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-2" }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "row mt-5 mb-5" }
const _hoisted_26 = {
  style: {"z-index":"20001","margin-top":"40px"},
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_history_content",
  "data-bs-backdrop": "static"
}
const _hoisted_27 = { class: "modal-dialog modal-md" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Detail History Siswa ", -1)
const _hoisted_31 = { class: "svg-icon svg-icon-2x" }
const _hoisted_32 = {
  class: "modal-body row",
  style: {"padding-left":"35px"}
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, "Detail Status Upload", -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas ")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_37 = { class: "col-7" }
const _hoisted_38 = { style: {"font-size":"12px"} }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Status ")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_42 = { class: "col-7" }
const _hoisted_43 = { style: {"font-size":"12px"} }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Status ")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_47 = { class: "col-7" }
const _hoisted_48 = { style: {"font-size":"12px"} }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container px-2 mt-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("hr", {
      style: {"width":"100%"},
      size: "5",
      color: "black"
    })
  ])
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, "Detail Data Siswa", -1)
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nama ")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_54 = { class: "col-7" }
const _hoisted_55 = { style: {"font-size":"12px"} }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 1 ")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_59 = { class: "col-7" }
const _hoisted_60 = { style: {"font-size":"12px"} }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 2 ")
], -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_64 = { class: "col-7" }
const _hoisted_65 = { style: {"font-size":"12px"} }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Kelas ")
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_69 = { class: "col-7" }
const _hoisted_70 = { style: {"font-size":"12px"} }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Kelas ")
], -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_74 = { class: "col-7" }
const _hoisted_75 = { style: {"font-size":"12px"} }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Jenis Kelamin ")
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_79 = { class: "col-7" }
const _hoisted_80 = { style: {"font-size":"12px"} }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Tanggal Lahir ")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_84 = { class: "col-7" }
const _hoisted_85 = { style: {"font-size":"12px"} }
const _hoisted_86 = { class: "row" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Tempat Lahir ")
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_89 = { class: "col-7" }
const _hoisted_90 = { style: {"font-size":"12px"} }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Tags ")
], -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_94 = { class: "col-7" }
const _hoisted_95 = { style: {"font-size":"12px"} }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Note ")
], -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_99 = { class: "col-7" }
const _hoisted_100 = { style: {"font-size":"12px"} }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container px-2 mt-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("hr", {
      style: {"width":"100%"},
      size: "5",
      color: "black"
    })
  ])
], -1)
const _hoisted_102 = { class: "row mt-5 mb-5" }
const _hoisted_103 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_history",
  "data-bs-backdrop": "static"
}
const _hoisted_104 = { class: "modal-dialog modal-xl" }
const _hoisted_105 = { class: "modal-content" }
const _hoisted_106 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Detail History ", -1)
const _hoisted_108 = { class: "svg-icon svg-icon-2x" }
const _hoisted_109 = { class: "modal-body row" }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-3" }
const _hoisted_112 = { class: "d-flex align-items-center position-relative" }
const _hoisted_113 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_114 = { class: "col-3" }
const _hoisted_115 = { class: "d-flex align-items-center position-relative" }
const _hoisted_116 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_117 = { class: "col-3" }
const _hoisted_118 = {
  class: "col-3",
  style: {"text-align":"end"}
}
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px; text-center" }, "Nomor Identitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Detail"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_122 = { key: 0 }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_124 = { class: "text-center" }
const _hoisted_125 = { class: "text-center" }
const _hoisted_126 = { class: "text-center" }
const _hoisted_127 = { class: "text-center" }
const _hoisted_128 = { class: "text-center" }
const _hoisted_129 = ["onClick"]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_131 = [
  _hoisted_130
]
const _hoisted_132 = { key: 1 }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, " Tidak Ada Data ")
], -1)
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = { class: "row mt-5 mb-5" }
const _hoisted_136 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_137 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_138 = ["label", "value"]
const _hoisted_139 = { class: "p-3" }
const _hoisted_140 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_141 = { class: "pagination" }
const _hoisted_142 = { class: "row mt-5 mb-5" }
const _hoisted_143 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_144 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_145 = ["label", "value"]
const _hoisted_146 = { class: "p-3" }
const _hoisted_147 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_148 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_date_picker, {
              "picker-options": _ctx.pickerOptions,
              modelValue: _ctx.dateAll,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateAll) = $event)),
              type: "daterange",
              "start-placeholder": "Tanggal Awal",
              "end-placeholder": "Tanggal Akhir",
              "value-format": "YYYY-MM-DD",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihTanggalAll()))
            }, null, 8, ["picker-options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Multiselect, {
              class: "mx-1",
              modelValue: _ctx.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
              placeholder: "Status",
              mode: "single",
              "create-option": false,
              options: _ctx.listStatus,
              searchable: true,
              label: "name",
              "track-by": "name",
              "value-prop": "_id",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihStatus($event)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              style: {"cursor":"pointer","margin-right":"10px"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
            }, " Reload Data "),
            _createElementVNode("a", {
              class: "btn btn-danger",
              "data-bs-toggle": "modal",
              style: {"cursor":"pointer"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/sekolah/card-design')))
            }, " Kembali ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(item.fileName), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(item.creatorName), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.dateTime(item.createTime)), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.status), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.detail), 1),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.detailHistory(item))
                        }, _hoisted_21, 8, _hoisted_19)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_22, _hoisted_24))
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", {
                    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModalHistorySiswa && _ctx.closeModalHistorySiswa(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.detaildatasiswa.nis), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.detaildatasiswa.status), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _hoisted_46,
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.detaildatasiswa.detail), 1)
                    ])
                  ]),
                  _hoisted_49,
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.detaildatasiswacontent.nama), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.detaildatasiswacontent.nis), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.detaildatasiswacontent.nisn), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _hoisted_68,
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.detaildatasiswacontent.kelas), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.detaildatasiswacontent.kelas_detail), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.detaildatasiswacontent.jenis_kelamin), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _hoisted_83,
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.detaildatasiswacontent.tanggal_lahir), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _hoisted_88,
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.detaildatasiswacontent.tempat_lahir), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _hoisted_93,
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.detaildatasiswacontent.tags), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _hoisted_97,
                    _hoisted_98,
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.detaildatasiswacontent.note), 1)
                    ])
                  ]),
                  _hoisted_101
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("div", _hoisted_106, [
                  _hoisted_107,
                  _createElementVNode("div", {
                    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_108, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _createElementVNode("div", _hoisted_112, [
                        _createElementVNode("span", _hoisted_113, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control ps-15",
                          placeholder: "Cari Nomor Identitas",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nisDetail) = $event)),
                          onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeNis(_ctx.e)))
                        }, null, 544), [
                          [_vModelText, _ctx.nisDetail]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", _hoisted_116, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control ps-15",
                          placeholder: "Cari Nama",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.namaDetail) = $event)),
                          onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePageSizeModal(_ctx.e)))
                        }, null, 544), [
                          [_vModelText, _ctx.namaDetail]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_117, [
                      _createVNode(_component_Multiselect, {
                        class: "mx-1",
                        modelValue: _ctx.statusDetail,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.statusDetail) = $event)),
                        placeholder: "Status",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.listStatusDetail,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "_id",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.pilihStatusDetail($event)))
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("a", {
                        class: "btn btn-warning",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.downloadHistoryExcel()))
                      }, " Download ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("table", _hoisted_120, [
                      _hoisted_121,
                      (_ctx.tableDataHistoryDetail.length)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_122, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataHistoryDetail, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _hoisted_123,
                                _createElementVNode("td", _hoisted_124, _toDisplayString(item.nis), 1),
                                _createElementVNode("td", _hoisted_125, _toDisplayString(item.name), 1),
                                _createElementVNode("td", _hoisted_126, _toDisplayString(item.status), 1),
                                _createElementVNode("td", _hoisted_127, _toDisplayString(item.detail), 1),
                                _createElementVNode("td", _hoisted_128, [
                                  _createElementVNode("a", {
                                    class: "symbol symbol-35px me-2",
                                    "data-bs-toggle": "tooltip",
                                    title: "Detail",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.detailHistorySiswa(item))
                                  }, _hoisted_131, 8, _hoisted_129)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_132, _hoisted_134))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("select", {
                            name: "kt_customers_table_length",
                            class: "form-select form-select-sm form-select-solid",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pagingmodal.size) = $event)),
                            placeholder: "Per page",
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changePageSizeModal()))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagingmodal.perPageOptions, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, _hoisted_138))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.pagingmodal.size]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_139, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.pagingmodal.totalElements) + " entries ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("ul", _hoisted_141, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item previous", { disabled: _ctx.pagingmodal.page + 1 === 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            style: {"cursor":"pointer"},
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.prevPageModal && _ctx.prevPageModal(...args)))
                          }, " Previous ")
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item next", {
                          disabled:
                            _ctx.pagingmodal.page + 1 === _ctx.pagingmodal.totalPages,
                        }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            style: {"cursor":"pointer"},
                            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.nextPageModal && _ctx.nextPageModal(...args)))
                          }, " Next ")
                        ], 2)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_142, [
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_145))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_146, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("ul", _hoisted_148, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}